import Requester from "../../common/network/http/Request";
import endpoints from "../../configs/endpoints";

export const fetchStateByName = async (stateName) => {
  try {
    const res = await Requester.get(endpoints.addresses.findStates, {
      search: stateName,
    }, null, false, false);

    return res.data[0];
  } catch (e) {
    return null;
  }
};

export const fetchCityByNameAndState = async (cityName, stateId, address) => {
  try {
    const res = await Requester.get(endpoints.addresses.findCities, {
      search: cityName,
      state: stateId,
      address,
    }, null, false, false);

    return res.data[0];
  } catch (e) {
    return null;
  }
};


export const fetchCitiesByState = async (stateId, search = "") => {
  try {
    const res = await Requester.get(endpoints.addresses.findCities, {
      state: stateId,
      search,
    }, null, false, false);

    return res.data;
  } catch (e) {
    return null;
  }
};
